module.exports = __webpack_public_path__ + "static/offer-brand-basic-1-a8f6019f15dabbc1c01779567bbc6cdd.jpg";